<template>
    <div class="bulk-notification-modal">
        <b-modal :id="modalId" no-close-on-backdrop no-close-on-esc>
            <template #modal-header>
                <h3>{{ title }}</h3>
            </template>
            <template>
                <b-form-group :invalid-feedback="invalidFeedback">
                    <h4>Subject:</h4>
                    <b-form-input
                        v-model="subject"
                        placeholder="Subject"
                        :state="subject !== null && subject !== ''"
                    />
                    <h4 style="margin-top: 15px">Message:</h4>
                    <b-form-textarea
                        v-model="message"
                        placeholder="Type your message here"
                        :state="message !== null && message !== ''"/>
                </b-form-group>
            </template>

            <template #modal-footer>
                <b-btn variant="danger" @click="closeModal()">
                    Cancel
                    <b-icon-x-square/>
                </b-btn>
                <b-btn variant="success" @click="sendMessage()">
                    Send
                    <b-icon-box-arrow-right/>
                </b-btn>
            </template>

            <b-collapse>
            </b-collapse>
            <b-alert show variant="primary" v-if="users">

                <p>Will be sent to <a v-b-toggle.user-collapse href="#">{{ users.length }} users</a> (Click to expand list)</p>
                <b-collapse id="user-collapse">
                    <ul>
                        <li v-for="user in users" :key="user.id">{{ user.email }}</li>
                    </ul>
                </b-collapse>
            </b-alert>

            <b-alert show variant="primary" v-if="equipment">

                <p>Will be sent to <a v-b-toggle.user-collapse href="#">{{ companies.length }} companies</a> (Click to expand list)</p>
                <b-collapse id="user-collapse">
                    <ul>
                        <li v-for="company in companies" :key="company.id">{{ company.name }}</li>
                    </ul>
                </b-collapse>
            </b-alert>

        </b-modal>
    </div>
</template>

<script>
export default {
    name: "BulkNotificationModal",
    props: {
        users: Array,
        equipment: Array,
        modalId: String,
    },
    data() {
        return {
            subject: null,
            message: null,
        }
    },
    computed: {
        title() {
            if (this.users) {
                return "Notification to Selected Users"
            }
            if (this.equipment) {
                return "Notification to Owners of Selected Equipment"
            }
            return ""
        },
        invalidFeedback() {
            let feedback = ''
            if (!this.subject) {
                feedback += 'Please enter a subject line. '
            }
            if (!this.message) {
                feedback += 'Please enter a message body.'
            }
            return feedback
        },
        companies() {
            let companies = []
            if(this.equipment) {
               this.equipment.forEach((e) => {
                   if(e.company && e.company.id && !companies.find((c) => e.company_id === c.id)) {
                       companies.push(e.company)
                   }
               })
           }
           return companies
        }
    },
    methods: {
        closeModal() {
            this.$bvModal.hide(this.modalId)
        },
        sendMessage() {
            const notification = {
                subject: this.subject,
                message: this.message,
            }
            if(this.users) {
                const userIds = this.users.map((user) => {
                    return user.id
                })
                notification['user_ids'] = userIds
            }
            if(this.equipment) {
                const companyIds = this.companies.map((company) => {
                    return company.id
                })
                notification['company_ids'] = companyIds
            }

            this.$api.sendBulkNotification(this, notification).then((response) => {
                this.$toasted.success('Message sent!')
            }, (error) => {
                this.$toasted.error(error.body)
            })
            this.closeModal()
        }
    }
}
</script>

<style scoped>

</style>